import React, { useState, useCallback } from 'react';
import { DocumentUploadZone } from '@/components/documents/DocumentUploadZone';
import { DocumentLibrary } from '@/components/documents/DocumentLibrary';
import { StatementsPanel } from '@/components/documents/StatementsPanel';

export const DocumentsPage = () => {
  const [reloadKey, setReloadKey] = useState(0);
  const refresh = useCallback(() => setReloadKey(k => k + 1), []);

  return (
    <div className="space-y-4" data-testid="documents-page">
      <h1 className="text-lg font-semibold text-[#1B2A4A]" style={{ fontFamily: 'IBM Plex Sans' }}>
        Documents
      </h1>
      <StatementsPanel />
      <DocumentUploadZone onUploaded={refresh} />
      <DocumentLibrary reloadSignal={reloadKey} />
    </div>
  );
};

export default DocumentsPage;
